var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { alpha, Grid, IconButton, lighten, Tooltip, Typography } from '@material-ui/core';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { useFormContext } from '../FormContext';
import { Alert } from '@material-ui/lab';
const StyledGrid = styled(Grid) `
  /* margin: 24px 0; */
  position: relative;
  z-index: 0;
  &.selected::before,
  &[data-edit]:hover::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: ${props => alpha(props.theme.palette.primary.main, 0.1)};
    border-radius: 4px;
    z-index: -1;
  }
  &.selected::before {
    border: solid 2px
      ${props => lighten(props.theme.palette.primary.main, 0.75)}; //#d0e5ff;
  }
  &[data-edit]:hover::before {
    background: rgba(148, 148, 160, 0.1);
  }
  &.selected:hover::before {
    background: ${props => alpha(props.theme.palette.primary.main, 0.1)};
  }
  .element-title {
    font-size: 15px;
    white-space: pre-wrap;
  }
  .element-description {
    font-size: 13px;
    white-space: pre-wrap;
  }
  .add-button {
    position: absolute;
    right: -17px;
    top: 50%;
    transform: translateY(-19px);
    .MuiIconButton-label {
      background: ${props => lighten(props.theme.palette.primary.main, 0.95)};
      border-radius: 24px;
    }
    svg {
      width: 32px;
      height: 32px;
      color: ${props => props.theme.palette.primary.main};
    }
  }
`;
// const FormElement: React.FC<
//   Omit<
//     React.ComponentProps<typeof StyledGrid>,
//     'onMouseDown' | 'onTouchStart' | 'onMouseOver' | 'onTouchMove'
//   > &
//     FormElementProps &
//     FormDragElementProps &
//     FormElementSelectProps
// >
export const FormElement = (_a) => {
    var _b, _c, _d, _e, _f;
    var { stateNode, element, edit, disabled, disableInlineSave, onClickAdd, onMouseDown, onTouchStart, onMouseOver, onTouchMove } = _a, props = __rest(_a, ["stateNode", "element", "edit", "disabled", "disableInlineSave", "onClickAdd", "onMouseDown", "onTouchStart", "onMouseOver", "onTouchMove"]);
    const { formState, elementPlugins } = useFormContext();
    const isSelected = edit && formState.selectedFormElement === element;
    return (React.createElement(StyledGrid, Object.assign({ item: true, 
        // ref={ref}
        xs: ((_b = element.breakpoints) === null || _b === void 0 ? void 0 : _b.xs) || 12, sm: (_c = element.breakpoints) === null || _c === void 0 ? void 0 : _c.sm, md: (_d = element.breakpoints) === null || _d === void 0 ? void 0 : _d.md, lg: (_e = element.breakpoints) === null || _e === void 0 ? void 0 : _e.lg, xl: (_f = element.breakpoints) === null || _f === void 0 ? void 0 : _f.xl, className: `form-element${isSelected ? ' selected' : ''}`, "data-edit": edit, onMouseDown: event => edit ? onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event, stateNode, element) : undefined, onTouchStart: event => edit ? onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(event, stateNode, element) : undefined, onMouseOver: event => edit ? onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(event, stateNode, element) : undefined, onTouchMove: event => edit ? onTouchMove === null || onTouchMove === void 0 ? void 0 : onTouchMove(event, stateNode, element) : undefined }, props),
        React.createElement(Typography, { variant: 'h6', className: 'element-title' }, element.title),
        element.description && (React.createElement(Typography, { className: 'element-description' }, element.description)),
        React.createElement("div", { className: 'form-element-answer' }, (() => {
            const plugin = elementPlugins.find(p => p.type === element.type);
            if (plugin === null || plugin === void 0 ? void 0 : plugin.element) {
                return (React.createElement(plugin.element, { stateNode: stateNode, element: element, edit: edit, disabled: disabled, disableInlineSave: disableInlineSave }));
            }
            return (React.createElement(Alert, { severity: 'error' },
                "Form element \"",
                element.type,
                "\" not found."));
        })()),
        isSelected && (React.createElement(Tooltip, { title: 'Add Form Element', placement: 'top', arrow: true },
            React.createElement(IconButton, { className: 'add-button', size: 'small', onClick: event => {
                    event.preventDefault();
                    onClickAdd === null || onClickAdd === void 0 ? void 0 : onClickAdd();
                } },
                React.createElement(AddCircleOutlineOutlinedIcon, null))))));
};
export default FormElement;
//# sourceMappingURL=FormElement.js.map